<template>
  <v-card class="rounded-0" elevation="0" width="100%">
    <v-list class="pa-0" v-for="(item, index) in list" :key="index">
      <v-list-group
        v-if="item.list.length > 0"
        class="list"
        :class="depth===0 ? 'top-level-group': '' "
        color="#999999"
        append-icon="mdi-menu-down"
        :value="groupStates[index]"
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title
              class="d-flex list_text"
              v-text="item.title"
            ></v-list-item-title>
          </v-list-item-content>
          <div class="border_bottom"></div>
        </template>

        <diagnosis_start_list :list="item.list" :depth="depth + 1" />
      </v-list-group>
      <v-list-item v-else class="list" :class="depth == 0 ? '' : 'dark'">
        <v-list-item-content>
          <v-list-item-title
            class="d-flex list_text"
            v-text="item.title"
          ></v-list-item-title>
        </v-list-item-content>
        <div class="border_bottom"></div>
        <v-btn class="list_button" @click="go(item)">
          {{ $ml.get("d_s_list_btn") }}
        </v-btn>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: "diagnosis_start_list",
  props: ["list", "depth"],
  data() {
    return {
      groupStates: Array(this.list.length).fill(true) //모든 그룹 열림
    };
  },
  methods: {
    go: function(val) {
      this.$store.state.diagnosis_data = val;
      this.$router.push("/d_info");
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/css/common";

.dark.list {
  background-color: $bg-color-d_s-list_bg_dark;
}

.border_bottom {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  border-bottom: solid 1px #767676;
}

.list_text {
  height: 50px;
  padding-left: 40px;
  align-items: center;
  font: normal normal normal 24px/32px Maple !important;
  letter-spacing: 0px;
  color: $ft-color-d_title;
}

.dark .list_text {
  padding-left: 50px;
  color: $ft-color-title-white;
  // padding: 0px 20px;
  // padding-left: 50px;
}

.list_button {
  margin-right: 40px;
  height: 50px !important;
  width: 100px;
  background-color: $bg-color-d_s-list_btn !important;
  color: $ft-color-d_s-list_btn !important;
  font: normal normal bold 24px/30px Noto !important;
}

.dark .list_button {
  background-color: $bg-color-d_s-list_dark_btn !important;
  color: $ft-color-d_s-list_dark_btn !important;
}

.sm {
  .list_text {
    height: calc(16vw - 24px);
    padding-left: 3vw;
    font: normal normal normal 4.5vw/5vw Maple !important;
    text-align: left;
  }

  .dark .list_text {
    padding-left: 4vw;
  }

  .list_button {
    margin-right: 3vw;
    min-width: 0px !important;
    height: 8vw !important;
    width: 14vw;
    font: normal normal normal 4vw/5vw Noto !important;
    border-radius: 30px;
  }
}

.top-level-group{
  width:100%;
}
</style>
<style lang="scss">
@import "src/assets/css/common";
/* vuetify custom */
.v-list-item__icon .v-icon {
  color: $ft-color-d_s-list_arrow !important;
  /*width: 100px;*/
  font-size: 60px !important;
  /*margin-right: 20px;*/
}

.sm .v-list-item__icon .v-icon {
  width: 8vw !important;
  font-size: 8vw !important;
}
</style>
